/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Switchtoperiod2Inputs */

const en_switchtoperiod2 = /** @type {(inputs: Switchtoperiod2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switch to ${i?.period}`)
};

const de_switchtoperiod2 = /** @type {(inputs: Switchtoperiod2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auf ${i?.period} umstellen`)
};

/**
* | output |
* | --- |
* | "Switch to {period}" |
*
* @param {Switchtoperiod2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const switchtoperiod2 = /** @type {((inputs: Switchtoperiod2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switchtoperiod2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_switchtoperiod2(inputs)
	return de_switchtoperiod2(inputs)
});
export { switchtoperiod2 as "switchToPeriod" }